import { CardOnFileActionsJustifiProps } from '../../../components/card-on-file/actions/actions-justifi';
import { CardOnFileActionsStripeProps } from '../../../components/card-on-file/actions/actions-stripe';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { useCardOnFileJustifiContext } from '../context/card-on-file-justifi.context';
import { useCardOnFileStripeContext } from '../context/card-on-file-stripe.context';

export type CardOnFileContextToActionsProps = {
  stripeComponent: React.FC<CardOnFileActionsStripeProps>;
  justifiComponent: React.FC<CardOnFileActionsJustifiProps>;
  shouldUsePadding?: boolean;
};
export const CardOnFileContextToActions = ({
  stripeComponent: StripeComponent,
  justifiComponent: JustifiComponent,
  shouldUsePadding,
}: CardOnFileContextToActionsProps) => {
  return (
    <GatewaySwitch
      stripeContent={StripeActionsWithContext}
      stripeProps={{ render: StripeComponent, shouldUsePadding }}
      justifiContent={JustifiActionsWithContext}
      justifiProps={{ render: JustifiComponent, shouldUsePadding }}
    />
  );
};

const StripeActionsWithContext = ({
  render: RenderStripeComponent,
  shouldUsePadding,
}: {
  render: React.FC<CardOnFileActionsStripeProps>;
  shouldUsePadding?: boolean;
}) => {
  const { primary, secondary, shouldShowFooter } = useCardOnFileStripeContext();

  return (
    <RenderStripeComponent
      shouldShow={shouldShowFooter}
      primary={primary}
      secondary={secondary}
      shouldUsePadding={shouldUsePadding}
    />
  );
};

const JustifiActionsWithContext = ({
  render: RenderJustifiComponent,
  shouldUsePadding,
}: {
  render: React.FC<CardOnFileActionsJustifiProps>;
  shouldUsePadding?: boolean;
}) => {
  const { primary, secondary, shouldShowFooter } = useCardOnFileJustifiContext();

  return (
    <RenderJustifiComponent
      shouldShow={shouldShowFooter}
      primary={primary}
      secondary={secondary}
      shouldUsePadding={shouldUsePadding}
    />
  );
};
